export default __webpack_public_path__ + "static/house6-d3b0a6fc8212a04c96420135e78e1293.png";